<script setup lang="ts">
    import { inject, onMounted, reactive, ref } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    // @ts-expect-error raison: lib externe mal typée
    import Vue3TagsInput from 'vue3-tags-input';

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        guid: "",
        nom: "", 
        valeurs: [],
    });
    const errors = reactive({
        nom: "",
        valeurs: "",
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.attribut) {
            const item = form_datas.attribut as any;
            formData.guid = item.guid;
            formData.nom = item.nom;
            formData.valeurs = item.valeurs;
        }
    });

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) {
            errors.nom ="Le nom est requis";
            isValid = false;
        }

        errors.valeurs = '';
        if (!formData.valeurs || formData.valeurs.length === 0) {
            errors.valeurs ="Au moins une énumération est requise";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                guid: formData.guid,
                nom: formData.nom,
                valeurs: formData.valeurs,
            };

            await axios.post(`/backoffice/market-attributs/save`, formToUpload);
            router.push('/app/market/market-attributs/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
    function handleChangeTag(newTags: any) {
        formData.valeurs = newTags;
    }
</script>

<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-30"></div>

        <section class="s20_mobile px-4">
            <div class="widget px-7 py-7">
                <h4 class="font-semibold mb-5">Attributs Market / Edition <span class="text-sm text-grey-500"></span></h4>

                <div class="form-field-floating reactive active my-4">
                    <input type="text" class="form-input" v-model="formData.nom" name="nom" id="nom" placeholder="" autocomplete="off">
                    <label for="nom">Libellé <b class="color-danger">*</b></label>
                </div>
                <span v-if="!!errors['nom']" class="text-red">{{ errors['nom'] }}</span>

                <div class="my-4">
                    <label for="nom">Valeurs <b class="color-danger">*</b></label>
                    <vue3-tags-input placeholder="Saisir les valeurs" @on-tags-changed="handleChangeTag" :tags="formData.valeurs" />
                </div>
                <span v-if="!!errors['valeurs']" class="text-red">{{ errors['valeurs'] }}</span>


                <div class="clear-both h-30"></div>
                <span v-if="!!errorMessage" class="text-red">{{ errorMessage }}</span>
                <p class="text-text-xs text-grey-500 mb-5"><b class="color-danger text-xs">*</b> Les champs marqués d'un astérisque sont obligatoires</p>
                <div class="flex gap-2">
                    <custom-button id="btn-submit" type="button" :classesList="'btn lg w-100'" :loading="loading" @click="onSubmit()">
                        <img src="/icons/icon-enregistrer.svg" class="btn-icon" alt="" />
                        <span>Enregistrer</span>
                    </custom-button>
                </div>
                
            </div>
        </section>
        
    </section>
</template>
